import SplashScreen from './SplashScreenPage'
export default SplashScreen;